export default __webpack_public_path__ + "static/media/muhammad-ariff.890977ff.png";